import * as styles from './index.css';
import { generatePath, useLocation, useParams } from 'react-router-dom';
import { EventScopeProvider } from '@blueshift-ui/analytics';
import MembershipUnchangedBanner from '../../components/membership/update/banners/unchanged';
import MembershipUpdatedBanner from '../../components/membership/update/banners/updated';
import { UPDATED_SUB_STATUSES } from '../../constants/sub-statuses';
import useAuthenticatedUser from '@blueshift-ui/auth/dist/hooks/use-authenticated-user';
import { useEffect } from 'react';
import useUserSubscriptions from '../../hooks/subscription/use-user-subscriptions';

interface LegacySettingsPageProps {
  routePath?: string;
}

function LegacySettingsPage({ routePath }: LegacySettingsPageProps) {
  const { isLoading: isLoadingUser, data: user } = useAuthenticatedUser();
  const routeParams = useParams() as Record<string, string>;
  const { search } = useLocation();
  const { data: userSubscriptions } = useUserSubscriptions({ userUuid: user?.user_id });

  const updatedSubscriptions = userSubscriptions?.filter((subscription) =>
    Object.values(UPDATED_SUB_STATUSES).find((uss) => subscription?.sub_statuses?.includes(uss))
  );
  const isUnchangedSubscription = search.includes('unchangedSubscription=true');

  /* Side-effects */

  useEffect(() => {
    function handleOpenContract(event: MessageEvent) {
      if (event.data.type === 'open-contract') {
        window.location.assign(event.data.payload.url);
      }
    }

    window.addEventListener('message', handleOpenContract);

    return function cleanup() {
      window.removeEventListener('message', handleOpenContract);
    };
  }, []);

  /* Render */

  if (!routePath || isLoadingUser) {
    return null;
  }

  return (
    <section>
      <EventScopeProvider eventScope={{ pageSection: 'memberships' }}>
        {!isUnchangedSubscription
          ? updatedSubscriptions?.map((subscription) =>
              subscription.sub_statuses?.map((subStatus) => (
                <MembershipUpdatedBanner
                  key={subscription.id}
                  subscription={subscription}
                  subStatus={subStatus}
                />
              ))
            )
          : null}

        {isUnchangedSubscription ? <MembershipUnchangedBanner /> : null}
      </EventScopeProvider>

      <iframe
        className={styles.iframe}
        src={new URL(
          `https://www.${process.env.VITE_DOMAIN_NAME}${generatePath(routePath, routeParams)}`
        ).toString()}
        title="Wrapped Experience"
      />
    </section>
  );
}

export default LegacySettingsPage;
